import React, { Component } from "react";
import { connect } from "react-redux";

class SettingsSubscription extends Component {
  render() {
    return (
      <div>

      </div>
    )
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedSettingsSubscription = connect(
  mapStateToProps,
  null
)(SettingsSubscription);
export default connectedSettingsSubscription;
